var staticStrLast = 'last'

module.exports = staticStrLast



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticStrLast.js
// module id = 82
// module chunks = 98